{
  "label": "Организация",
  "rename": "Изменить название организации",
  "dialogTitle": "Название организации",
  "nameLabel": "Название",
  "nameHint": "Видно всем сотрудникам организации — в шапке платформы и в письмах уведомлений",
  "saving": "Сохраняем…"
}
